/**************************************************
 * Nombre:       Seccion_Cap
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import React, {useEffect, useState} from "react";
import {theme} from "../../Tema";
import {where} from "firebase/firestore";
import {obtenerColWheres} from "../../Servicios/BD/obtenerColWheres";
import {useParams} from "react-router-dom";
import {usePasosFormularios} from "../../Modulo_Pasos/Hooks/usePasosFormularios";
import Tarjeta_Contenido_Cap from "../Tarjetas/Tarjeta_Contenido_Cap";
import {useDialogo} from "../../Modulo_Dialogos_2025/Hooks/useDialogo";
import Dialogo_Test from "../Dialogos/Dialogo_Test";
import {obtenerDoc} from "../../Servicios/BD/obtenerDoc";
import {useResponsive} from "../../Modulo_Responsive/Hooks/useResponsive";
import {ArrowBack} from "@mui/icons-material";


const Seccion_Cap = () => {
    const {sCell} = useResponsive()
    const parms = useParams()
    const [contenidos, setContenidos] = useState([])
    const [todoContenido, setTodoContenido] = useState({})
    const {Dialogo, abrir} = useDialogo({Componente: Dialogo_Test, titulo: 'Test de conocimiento'})
    const {Pasos} = usePasosFormularios({
        datos: {},
        formularios: contenidos,
        textoBoton: 'Realizar Test',
    })
    const [capacitacion, setCapacitacion] = useState({})

    const transformarContenidos = (arr) => {

        let arrConte = []
        for (let i = 0; i < arr.length; i++) {

            let conte = arr[i]

            let Conten = () => {
                return (
                    <Tarjeta_Contenido_Cap item={conte}/>
                )
            }

            arrConte.push(Conten)
        }

        setContenidos(arrConte)

    }

    const vercontenido = () => {
        abrir(todoContenido)
        console.log(todoContenido)
    }


    useEffect(() => {

        if (parms.id) {
            // console.log(parms.id)


            obtenerDoc('capacitaciones', parms.id).then((dox) => {
                if (dox.res && dox.data) {
                    setCapacitacion(dox.data)
                }
            })


            let w = [where('idCapacitacion', '==', parms.id)]
            obtenerColWheres({col: 'contenidos', wheres: w}).then((dox) => {
                if (dox.data && dox.data) {
                    let conten = dox.data[0]
                    setTodoContenido(conten)
                    transformarContenidos(conten.contenidos);
                }
            })

        }

    }, [parms])
    return (

        <Grid container size={{xs: 12, sm: 12, md: 12}} justifyContent={'center'}>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{marginTop: 2.5, maxWidth: '1200px', pb: 6}}
                spacing={0}
            >

                <Dialogo/>

                <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'center'}
                        alignItems={'center'}
                        size={{xs: 12, sm: 12, md: 12}}>

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: -4}}>
                            <Button
                                onClick={() => window.history.back()}
                                variant={'text'} startIcon={<ArrowBack/>}>Atras</Button>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 2}}>
                            <Grid
                                container
                                justifyContent={'flex-start'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 12, md: 12}}>

                                <Grid container size={{xs: 12, sm: 6, md: 6}} sx={{justifyContent: 'flex-start'}}>
                                    <Typography sx={{
                                        color: theme.palette.primary.main,
                                        fontSize: sCell ? 24 : 36,
                                        fontWeight: 800,
                                        lineHeight: 1.1
                                    }}>
                                        {capacitacion.nombre}
                                    </Typography>
                                </Grid>

                                <Grid container size={{xs: 12, sm: 6, md: 6}}
                                      sx={{justifyContent: 'flex-start', mt: sCell ? 1.5 : 0}}>
                                    <Typography sx={{fontSize: 14, fontWeight: 400}}>
                                        {capacitacion.descripcion}
                                    </Typography>
                                </Grid>

                            </Grid>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 7, md: 10}} sx={{justifyContent: 'flex-start', mt: 8}}>
                            <Pasos finalizar={vercontenido}/>
                        </Grid>

                    </Grid>
                </Grid>


            </Grid>

        </Grid>
    )

}
export default Seccion_Cap

